import React from 'react';
import {IndexLink, Link} from 'react-router';
import * as commonApi from '../../../api/common-api';
import * as courseApi from '../../../api/course-api';
import {connect} from 'react-redux';
import Loading from 'react-loading';
import axios from 'axios';

var querystring = require('querystring');
import Textarea from 'react-textarea-autosize';


import ReactDOM from 'react-dom';


//var termArr = [];
class ProfileBio extends React.Component {
    constructor(props) {
        super(props);

        var my = false;
        if (this.props.user.id_account == this.props.profileId) {
            my = true;
        }

        this.state = {
        	loading: false,
			profileId: this.props.profileId,
			my: my,
			bio: "",
			ebio: "",
			show: false
        };
    }


    componentDidMount() {
    	console.log(this.state)
        this.setState({loading: true, bio: this.props.cuser.about_account}, () => {
            this.getBio();
        });
    }

    componentWillReceiveProps(nextProps) {
        var my = nextProps.my;

        var loading = false;
        if (nextProps.profileId != this.props.profileId) {
            loading = true;
        }
        if (loading) {
            this.setState({loading: loading, profileId: nextProps.profileId, my: my, bio: ""}, () => {
                this.getBio();
            });
        } else {
            this.setState({profileId: nextProps.profileId, my: my});
        }
    }

    getBio() {
        axios.get(commonApi.getAPIURL() + '?api=getUserBio&user_id=' + this.state.profileId)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({bio: response.data.data.about_account});
                }
                this.setState({loading: false});
                return response;
            });
    }

    add(e) {
        this.setState({show: true, ebio: this.state.bio});
    }

    cancel(e) {
        this.setState({show: false});
    }

    save(e) {
        var bio = this.state.ebio;
        var data = new FormData();
        data.append('bio', bio);
        axios.post(commonApi.getAPIURL() + '?api=updateBio', data)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({bio: bio, show: false});
                }
                return response;
            }).catch(error => {
        });
    }

    onBioChange(e) {
        this.setState({ebio: e.target.value});
    }


    render() {
        var avatar = <img className="img_circle" src='/static/img/appimg/common-noavatar-sm.jpg'/>;
        if (this.props.cuser != undefined) {
            if (this.props.cuser.image_avatar_account > 0) {
                avatar = <img className="img_circle" src={this.props.cuser.link_thumb_file}/>;
            }
        }

        if (this.state.bio === null) this.state.bio = "";
        return (
            <div className={(this.state.my || this.state.bio.length > 0) && this.state.loading == false ? "page_course_box profile_content_wrapper" : "hide-el"} style={{position: 'relative'}}>
                <div className="title_box">
                    <img src="/static/img/appimg/icon_bio.png"/>
                    <div className="title">Short Bio</div>
                </div>
                {this.state.bio != undefined && this.state.bio.length > 0 && this.state.show == false && this.state.my ? (<a style={{position: 'absolute', top: '12px', right: '10px'}} onClick={this.add.bind(this)}><img src="/static/img/appimg/email-icon03.png"/></a>) : ""}
                {this.state.show == true ? (
                    <div>
                        <div style={{marginTop: '5px'}}>
                            <Textarea className="textarea" placeholder="" name="content" onChange={this.onBioChange.bind(this)} value={this.state.ebio}/>
                        </div>
                        <div className="inline_block">
                            <a onClick={this.save.bind(this)} style={{padding: '9px 15px'}} className="btn_v btn_confirm fright">Save</a>
                            <a onClick={this.cancel.bind(this)} style={{padding: '9px 15px', marginRight: '5px'}} className="btn_v btn_cancel fright">Cancel</a>
                        </div>
                    </div>
                ) : (
                	<div>
                        {this.state.bio != undefined && this.state.bio.length > 0 ? (
                            <div style={{textAlign: 'center', fontSize: '9pt'}}>
                                <div>{avatar}</div>
                                {this.state.bio}

                            </div>) : (
                            <div style={{textAlign: 'center', fontSize: '8pt'}}>
                                <div>{avatar}</div>
                                <div style={{fontSize: '9pt'}}><b>Tell us a little about yourself!</b></div>
                                <div>What are your goals?</div>
                                <div>What are your experiences of skill?</div>
                                <div>What are one or two fun facts about yourself?</div>
                                {this.state.my ? (<div><a onClick={this.add.bind(this)} style={{padding: '9px 15px'}} className="btn_v btn_confirm">Add Bio</a></div>) : ""}
                            </div>)}
                    </div>
                )
                }
            </div>

        )
    }
}

export default ProfileBio;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/profile/profile_bio.js
 **/